<template>
  <button
    class="answers-button w-fit py-[0.3rem] px-[1rem] rounded-[8px] text-black text-[15px] text-center cursor-pointer line-clamp-6"
    @click="$emit('handleAnswer')"
  >
    {{ answer }}
  </button>
</template>
<script setup>
  const props = defineProps({
    answer: {
      type: String,
      required: false,
      default: "",
    },
  })
</script>
